import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { SearchOutlined } from "@ant-design/icons";
import { Table } from "antd";
import axios from "axios";
const DEPNONComplainceTable = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const localData = JSON.parse(localStorage.getItem("selectedproperties"));
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    fetchData();
  }, []);


 
 
  const fetchData = async () => {
    setLoading(true);
    try {
      const promises = localData.map(async (v) => {
        if (v.boro) {
          console.log("vvvvvvvvvvvv", v.boro);
          const response = await axios.get(
            `https://data.cityofnewyork.us/resource/n4tc-j6kh.json?borough_name=${v.boro}`
          );
          console.log(response);
          return response.data;
          
        }
      });
      const responseData = await Promise.all(promises);
      setData(responseData.flat()); // Assuming responseData is an array of arrays
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  





  const columns = [
    {
      title: "School Code",
      dataIndex: "school_code",
    },
    {
      title: "DOB Boiler Id",
      dataIndex: "dob",
    
    },
    {
      title: "Category",
      dataIndex: "inspection_category",
    },
    {
      title: "Type of Inspection",
      dataIndex: "date_requested",
      sorter: (a, b) => new Date(a.date_requested) - new Date(b.date_requested),
      render: (text, record) => (
        <div
          style={{ cursor: "pointer" }}
          // onClick={() => handleRowClick(record)}
        >
          {new Date(text).toLocaleDateString("en-US")}
        </div>
      ),
      
    },
    {
      title: "Status",
      dataIndex: "request_status_description",
      render: () => (
        <div
          onClick={() => navigate("/corrections_view")}
          style={{ color: "black", cursor: "pointer", display: "flex" }}
        >
          <SearchOutlined className="icons-documentation1" />
        </div>
      ),
      
    },
    
  ];
  return (
    <>
      <div style={{ padding: "20px" }}>
        <Table columns={columns} dataSource={data} size="middle" />
      </div>
    </>
  );
};

export default DEPNONComplainceTable;
